import { RouteObject } from "react-router-dom";
import { ReportsMain, REPORTS_MAIN_PATH } from "./pages/main";

export const reports: RouteObject[] = [
  {
    path: REPORTS_MAIN_PATH,
    element: <ReportsMain />,
  },
];
